export default "__VITE_ASSET__CQUY3DZr__"